<script setup>
  import { ref, onBeforeMount, onUnmounted} from "vue";
  import router from "@/router";

  import DefaultLayout from "@/views/layouts/DefaultLayout.vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  const companyStore = useCompanyStore();
  const companyId = companyStore.companyId;
  const uiStore = useUiStore();
  let settingsArr = ref([]);
  let isLoading = ref(true);
  let notify_when_online = ref(null)
  let notify_when_is_active = ref(null)
  let notify_interval = ref(null)
  let isSubmitted = ref(false);
  
  const onSubmit = async() => {

    isSubmitted.value = true;
    settingsArr.value.map( (obj) =>{
        if(obj.name == 'offline_device_check'){
            obj.value.interval = notify_when_is_active.value ? notify_interval.value.toString() : 5;
            obj.value.is_active = notify_when_is_active.value ? 'true' : 'false' ;
            obj.value.notify_when_online =  notify_when_online.value ? 'true' : 'false' ;
        }
        obj.value = JSON.stringify(obj.value);
    });

    const data = {
      settings: settingsArr.value,
      companyId,
    };

    companyStore.updateCompanySettings(data)
    .then(() => {
      isSubmitted.value = false;
      router.push("/dashboard");
    }).catch(() => {
      isSubmitted.value = false;
    });

  };
  
  onBeforeMount( () => {
    companyStore.getCompanySettings(companyId)
    .then( async(res) => {
      if(res && res.data && res.data.settings.length){
        await res.data.settings.map( async (obj) => {
        if(obj.name == 'offline_device_check'){
            obj.pivot.value = await JSON.parse(obj.pivot.value);
            notify_when_online.value = await obj.pivot?.value?.notify_when_online === 'true' ? true : false;
            notify_interval.value = await parseInt(obj.pivot?.value?.interval);
            notify_when_is_active.value = await obj.pivot?.value?.is_active === 'true' ? true : false;
        }

        let newObj = {};
          newObj.id = obj.id;
          newObj.name = obj.name;
          newObj.value = obj.pivot.value;
          settingsArr.value.push(newObj);
        });
      }

    //      isLoading.value = false;
    }).catch(() => {
    })
  });

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onUnmounted( () => {
    resetStoreData();
  });

</script>

<template>
  <DefaultLayout>
    <div class="general-settings-card main-page-container-animation">
      <!-- Nav tabs -->
      <div v-if="isLoading" class="flex justify-center mb-3">
          <div class="spinner-border text-success" role="status">
              <span class="visually-hidden">Loading...</span>
          </div>
      </div>
      <div v-else>
        <div>
            <div class="justify-between items-center mb-3 text-center">
                <div class="flex items-center">
                    <div class="form-check mr-30">
                        <input class="form-check-input" type="checkbox" v-model="notify_when_is_active" id="deviceOffline">
                        <label class="form-check-label ml-10" for="deviceOffline">
                            Connection Policy
                        </label>
                    </div>

                    <div class="form-floating flex" :class="{'disabled-div' : !notify_when_is_active }"> 
                        <input :disabled="!notify_when_is_active"  v-model="notify_interval" min="5" type="number" class="w-335 form-control input-remove-right-border-radius " id="interval" placeholder="Interval" />
                        <label for="interval">Notify when device is not connected for</label> 
                        <div class="input-border-wrapper">
                          <div class="input-border"></div>
                        </div>
                        <div class="minutes-label">
                          <div class="minutes">Minutes</div>
                        </div>
                    </div>

                </div>

                <div class="flex items-center mt-20">

                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="notify_when_online" id="deviceOnline">
                      <label class="form-check-label ml-10" for="deviceOnline">
                          Notify when device is comes back
                      </label>
                    </div>

                </div>

            </div>
        </div>

        <div class="flex mt-20 float-right right-bottom-btn">
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Submit <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>